
import { Component, Vue } from "vue-property-decorator";
import { MarketStore, MMCMembersStaffStore } from "@/store/modules";

@Component
export default class ContactPerson extends Vue {
  show = false;
  hideButton = false;

  get mmcMemberStaffData() {
    return MMCMembersStaffStore.MMCMemberStaffList;
  }

  created() {
    let routeName = this.$route.name;
    const queryParams = {
      market_id: MarketStore.MARKETPLACE_ID,
    };
    MMCMembersStaffStore.getMMCMemberStaffList(queryParams);
    if (routeName == "Home") {
      // for (let i = 0; i < 4; i++) {
      //   this.itemList.push(this.mmcMemberStaffData[i]);
      // }
      this.hideButton = false;
    }

    if (routeName == "Contact") {
      // this.itemList = this.mmcMemberStaffData;
      this.hideButton = true;
    }
  }

  navigateToContactScreen() {
    this.$router.push({
      name: "Contact",
    });
  }
}
